import React from 'react'
import Navbar from '../components/Navbar'
import HeroImage from '../components/HeroImage'
import Footer from '../components/Footer'
import AdminLogin from '../components/AdminLogin'

const Admin = () => {
  return (
    <div>
        <AdminLogin/>
    </div>
  )
}

export default Admin